<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="bookings"
      :single-expand="singleExpand"
      :expanded.sync="expanded"
      item-key="id"
      show-expand
      :loading="loading"
      :custom-sort="customSort"
      class="elevation-1 col-12 pa-0 pa-sm-3"
    >
      <template v-slot:top> </template>
      <template v-slot:[`item.icon`]="{ item }">
        <v-icon :color="statusAttrs(item.status, item).color">
          {{ statusAttrs(item.status, item)["icon"] }}
        </v-icon>
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <div class="overline">
          {{ statusAttrs(item.status, item).status_admin }}
        </div>
      </template>
      <template v-slot:[`item.guestname`]="{ item }">
        {{ item.user.lastname + " " + item.user.firstname }}
      </template>
      <template v-slot:[`item.lastmodified`]="{ item }">
        {{
          item.transitions[item.transitions.length - 1]
            ? formatDateTime(
                item.transitions[item.transitions.length - 1].created
              )
            : ""
        }}
      </template>
      <template v-slot:[`item.arrival`]="{ item }">
        {{ formatDate(item.arrival) }}
      </template>
      <template
        v-slot:[`item.actions`]="{ item }"
        v-if="$vuetify.breakpoint.smAndUp"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              :disabled="loading"
              v-if="item.status == 'TENTATIVE' || item.status == 'BOOKED'"
              fab
              v-bind="attrs"
              v-on="on"
              @click="mouseClickAccept(item)"
              x-small
              color="transparent"
              class="mt-auto align-self-end mr-2"
              ><v-icon small color="success">
                {{ statusAttrs(item.status, item).action_admin_icon_ok }}
              </v-icon>
            </v-btn>
          </template>
          <span class="text-caption">{{
            statusAttrs(item.status, item).action_admin_ok
          }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              :disabled="loading"
              v-if="item.status == 'TENTATIVE' || item.status == 'BOOKED'"
              fab
              v-bind="attrs"
              v-on="on"
              @click="mouseClickCancel(item)"
              x-small
              color="transparent"
              class="mt-auto align-self-end mr-2"
              ><v-icon small color="corange">
                {{ statusAttrs(item.status, item).action_admin_icon_cancel }}
              </v-icon>
            </v-btn>
          </template>
          <span class="text-caption">{{
            statusAttrs(item.status, item).action_admin_cancel
          }}</span>
        </v-tooltip>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize"> Frissítés </v-btn>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <div class="d-flex flex-wrap">
            <booking-tabs
              :booking="item"
              :admin="true"
              class="py-4 col-12 col-sm-10 pa-0 pa-sm-3"
            ></booking-tabs>
            <div class="col-12 col-sm-2">
              <v-btn
                :disabled="loading"
                v-if="item.status == 'TENTATIVE' || item.status == 'BOOKED'"
                large
                text
                class="d-flex justify-start caption"
                @click="mouseClickAccept(item)"
              >
                <v-icon small left color="success">
                  {{ statusAttrs(item.status, item).action_admin_icon_ok }}
                </v-icon>
                {{ statusAttrs(item.status, item).action_admin_ok }}
              </v-btn>
              <v-btn
                :disabled="loading"
                v-if="item.status == 'TENTATIVE' || item.status == 'BOOKED'"
                large
                text
                class="d-flex justify-start caption"
                @click="mouseClickCancel(item)"
              >
                <v-icon small left color="corange">
                  {{ statusAttrs(item.status, item).action_admin_icon_cancel }}
                </v-icon>
                {{ statusAttrs(item.status, item).action_admin_cancel }}
              </v-btn>
              <v-btn
                :disabled="loading"
                large
                text
                class="d-flex justify-start caption"
                @click="mouseClickUpdate(item)"
              >
                <v-icon small left color="primary"> fa-pencil </v-icon>
                Állapot módosítás
              </v-btn>
              <v-btn
                :disabled="loading"
                v-if="!active"
                large
                text
                class="d-flex justify-start caption"
                @click="mouseClickDelete(item)"
              >
                <v-icon small left color="error"> fa-trash </v-icon>
                Végleges törlés
              </v-btn>
            </div>
          </div>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import ApiService from "../../services/api.service";
import BookingDataService from "../../services/bookingData.service";
import BookingTabs from "./BookingTabs.vue";
import MomentService from "../../services/moment.service";
import SortService from "../../services/sort.service";

export default {
  name: "CAdminBookingTable",
  components: { BookingTabs },
  props: ["bookings", "active"],
  data: () => ({
    loading: false,
    expanded: [],
    singleExpand: true,
    headers: [
      { text: "", value: "data-table-expand" },
      {
        text: "",
        align: "end",
        value: "icon",
        sortable: false,
      },
      {
        text: "Státusz",
        align: "start",
        value: "status",
      },
      { text: "Legutoljára módosítva", value: "lastmodified" },
      { text: "Vendég", value: "guestname" },
      { text: "Érkezés", value: "arrival" },
      { text: "", value: "actions", sortable: false },
    ],
    selectedBooking: {},
    payload: {
      comment: "",
      newStatus: "",
    },
    actionType: "",
  }),
  mounted() {},
  computed: {},
  methods: {
    customSort(items, index, isDesc) {
      return SortService.sortBookings(items, index, isDesc);
    },
    mouseClickAccept(item) {
      this.selectedBooking = item;
      this.actionType = "accept";
      if (item.status == "TENTATIVE") {
        this.payload.newStatus = "BOOKED";
      }
      if (item.status == "BOOKED") {
        this.payload.newStatus = "PAID";
      }

      this.$store.commit("dialog/openDialogWithForm", {
        title: this.statusAttrs(item.status, item).action_admin_ok,
        confirmButton: "OK",
        onConfirm: (form) => {
          return this.dialogOkEvent(form);
        },
        form: {
          textfieldLabel:
            "Írj rövid üzenetet, egyéb megjegyzést a vendégnek, ha szeretnél.",
          textfieldRequired: false,
        },
      });
      return;
    },
    mouseClickCancel(item) {
      this.selectedBooking = item;
      this.actionType = "cancel";
      if (item.status == "TENTATIVE" || item.status == "BOOKED") {
        this.payload.newStatus = "DELETED";
      }
      this.$store.commit("dialog/openDialogWithForm", {
        title: this.statusAttrs(item.status, item).action_admin_cancel,
        text: "Biztosan el szeretnéd utasítani a foglalást?",
        confirmButton: "ELUTASÍTÁS",
        confirmButtonColor: "error",
        onConfirm: (form) => {
          return this.dialogOkEvent(form);
        },
        form: {
          textfieldLabel:
            "Írj indoklást a vendégnek, hogy miért nem megfelelő a foglalása!",
          textfieldRequired: true,
        },
      });
      return;
    },
    mouseClickUpdate(item) {
      this.selectedBooking = item;
      this.actionType = "update";
      this.$store.commit("dialog/openDialogWithForm", {
        title: "Foglalás státuszának módosítása",
        text: "Ez a funkció csak különleges esetek kezelésére szolgál. Csak akkor használd, ha szükséges!",
        confirmButton: "MÓDOSÍTÁS",
        confirmButtonColor: "success",
        onConfirm: (form) => {
          return this.dialogOkEvent(form);
        },
        form: {
          textfieldLabel:
            "Írj magyarázatot a vendégnek! Mi miatt módosul a foglalás státusza?",
          textfieldRequired: false,
          dropdownLabel: "Válaszd ki a foglalás új állapotát",
          dropdownItems: [
            {
              name: this.statusAttrs("TENTATIVE", null).status_admin,
              status: "TENTATIVE",
            },
            {
              name: this.statusAttrs("BOOKED", null).status_admin,
              status: "BOOKED",
            },
            {
              name: this.statusAttrs("PAID", null).status_admin,
              status: "PAID",
            },
            {
              name: this.statusAttrs("DELETED", null).status_admin,
              status: "DELETED",
            },
            {
              name: this.statusAttrs("OUTDATED", null).status_admin,
              status: "OUTDATED",
            },
          ].filter(function (s) {
            return s.status !== item.status;
          }),
        },
      });
      return;
    },
    mouseClickDelete(item) {
      console.log("mouse clikc on delete")
      this.actionType = "delete";
      this.selectedBooking = item;
      this.$store.commit("dialog/openSimpleDialog", {
        title: "Foglalás végleges törlése",
        text: "Biztosan ki szeretnéd véglegesen törölni a foglalást? Ezt a műveletet nem lehet visszavonni, mivel az adatbázisból is törlődik a foglalás.",
        confirmButton: "TÖRLÉS",
        confirmButtonColor: "red",
        onConfirm: () => {
          return this.deleteBooking();
        },
      });
      return;
    },
    dialogOkEvent(result) {
      console.log("ok event")
      if (this.actionType !== "delete") {
        if (this.actionType === "update") {
          this.payload.newStatus = result.newStatus;
        }
        this.payload.comment = result.comment;
        this.loading = true;
        ApiService.PUT("booking/" + this.selectedBooking.id, this.payload)
          .then((response) => {
            this.$emit("statusChanged", response.data);
            this.$store.commit("showMessage", {
              active: true,
              color: "success", // You can create another actions for diferent color.
              message: "Foglalás státusza sikeresen módosítva",
            });
            this.loading = false;
          })
          .catch((error) => {
            this.$store.commit("showMessage", {
              active: true,
              color: "error",
              message:
                "Nem sikerült lemondani a foglalást. Próbáld újra, vagy mondd le telefonon vagy emailben!",
            });
            this.loading = false;
          });
      }
      return;
    },
    deleteBooking() {
      console.log("deletebooking")
      this.loading = true;
      ApiService.DELETE("booking/" + this.selectedBooking.id)
        .then((response) => {
          var that = this;
          this.bookings = this.bookings.filter(function (booking) {
            return booking.id !== that.selectedBooking.id;
          });
          this.$store.commit("showMessage", {
            active: true,
            color: "success", // You can create another actions for diferent color.
            message: "Foglalás sikeresen törölve",
          });
          this.loading = false;
        })
        .catch((error) => {
          this.$store.commit("showMessage", {
            active: true,
            color: "error",
            message: "Nem sikerült törölni a foglalást",
          });
          this.loading = false;
        });
    },
    formatDate(d) {
      return MomentService.formatDate(d);
    },
    formatDateTime(d) {
      return MomentService.formatDateTime(d);
    },
    statusAttrs(status, booking) {
      return BookingDataService.bookingStatusAttrsForUser(status, booking);
    },
  },
};
</script>
